
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.206 22.645c.435.474 1.15.474 1.585 0l5.549-6.042c.435-.474.435-1.255 0-1.726a1.068 1.068 0 00-.793-.35H19.7V2.288a.667.667 0 00-.16-.442.573.573 0 00-.408-.179h-4.268c-.147 0-.309.068-.408.176s-.162.282-.16.447l-.002 12.237-2.844-.003c-.297 0-.582.124-.793.353-.433.471-.433 1.253 0 1.726l5.549 6.042zM30.327 27H3.673A2.67 2.67 0 001 29.667a2.664 2.664 0 002.673 2.667h26.653a2.67 2.67 0 002.673-2.667A2.662 2.662 0 0030.327 27z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    